import { useTranslate } from "@tolgee/react";
import { ChevronRight } from "lucide-react";
import { LocalizedLink } from "#/components/locale/localized-link";
import type { Post } from "#/lib/api/posts";
import { LEARN_SECTIONS } from "../content";

/** 섹션 = post.category (백엔드 enum이 learn 섹션 슬러그와 1:1).
 *  섹션 순서는 LEARN_SECTIONS 고정(문서 지침: 섹션 배치는 프론트 몫),
 *  섹션 내 순서는 sort_order 오름차순 — 문서 지침대로 카테고리 버킷 후 정렬
 *  (도착 순서 의존 금지; 안정 정렬이라 sort_order 동률은 최신순 유지). */
export function LearnSections({ posts }: { posts: readonly Post[] }) {
	const { t } = useTranslate();

	return (
		<div className="mb-8 flex flex-col divide-y divide-border [&>*]:py-5 [&>*:first-child]:pt-0 [&>*:last-child]:pb-0">
			{LEARN_SECTIONS.map((section) => {
				const entries = posts
					.filter((post) => post.category === section.slug)
					.sort((a, b) => a.sort_order - b.sort_order);
				if (entries.length === 0) return null;
				return (
					<div key={section.slug}>
						<h2 className="mb-3 text-body2-bold uppercase text-muted-foreground">
							{t(section.titleKey)}
						</h2>
						<ul className="flex flex-col">
							{entries.map((post) => (
								<li
									key={post.slug}
									className="border-b border-border last:border-b-0"
								>
									<LocalizedLink
										to="/learn/$slug"
										params={{ slug: post.slug }}
										className="flex items-center justify-between px-4 py-3 text-body2-medium text-foreground transition-colors hover:bg-muted/50"
									>
										<span className="whitespace-pre-line">{post.title}</span>
										<ChevronRight className="h-4 w-4 shrink-0 text-muted-foreground" />
									</LocalizedLink>
								</li>
							))}
						</ul>
					</div>
				);
			})}
		</div>
	);
}
